export const Constants = {
    // LOT
    LOT_AUCTION_STATUS_PENDING: 0,
    LOT_AUCTION_STATUS_SOLD: 1,
    LOT_AUCTION_STATUS_UNSOLD: 2,
    LOT_AUCTION_STATUS_WITHDRAWN: 3,
    LOT_AUCTION_STATUS_WITHDRAWN_AN: 4,
    LOT_AUCTION_STATUS_SOLD_POST: 5,
    LOT_AUCTION_STATUS_WITHDRAWN_30: 6,
    LOT_AUCTION_STATUS_OPEN: 7,

    // AUCTION
    AUCTION_LIVE_STATUS_STANDBY: 0,
    AUCTION_LIVE_STATUS_AUCTIONING: 1,
    AUCTION_LIVE_STATUS_BREAK: 2,
    AUCTION_LIVE_STATUS_ENDED: 3,
    AUCTION_LIVE_STATUS_HOME: 89,
    AUCTION_LIVE_STATUS_OLD: 99,
    AUCTION_LIVE_STATUS_RELOAD: 109,
    
    // LOTS LIST
    LOTS_SHOW_PASED: 1,
    LOTS_SHOW_AVAILABLE: 2,
}

export const Labels = {
    getAuctionLiveStatusLabel(status) {
        switch (status) {
            case Constants.AUCTION_LIVE_STATUS_STANDBY:
                return 'Standby';
            case Constants.AUCTION_LIVE_STATUS_AUCTIONING:
                return 'Auctioning';
            case Constants.AUCTION_LIVE_STATUS_BREAK:
                return 'Break';
            case Constants.AUCTION_LIVE_STATUS_ENDED:
                return 'Ended';
            case Constants.AUCTION_LIVE_STATUS_HOME:
                return 'Redirect home';
            case Constants.AUCTION_LIVE_STATUS_OLD:
                return 'Redirect old';
            default:
                return 'N/A';
        }
    },
    getAuctionStatusLabel(status) {
        switch (status) {
            case Constants.LOT_AUCTION_STATUS_PENDING:
                return 'Pending';
            case Constants.LOT_AUCTION_STATUS_SOLD:
                return 'Sold';
            case Constants.LOT_AUCTION_STATUS_UNSOLD:
                return 'Pass';
            case Constants.LOT_AUCTION_STATUS_WITHDRAWN:
                return 'Withdrawn';
            case Constants.LOT_AUCTION_STATUS_WITHDRAWN_30:
                return 'Withdrawn';
            case Constants.LOT_AUCTION_STATUS_WITHDRAWN_AN:
                return 'Withdrawn';
            case Constants.LOT_AUCTION_STATUS_SOLD_POST:
                return 'Sold post';
            case Constants.LOT_AUCTION_STATUS_OPEN:
                return 'Open';
            default:
                return 'N/A';
        }
    }
}
